"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brivio": {
    "86ff86e3": [{
      "hkey": "f0b148b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "bastiglia": [{
      "hkey": "f0b148b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brivio"
    }],
    "66de7269": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "skipSearch": false
    }],
    "butto": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dea9ca68": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "skipSearch": false
    }],
    "canosse": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ee637bfa": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "skipSearch": false
    }],
    "foino": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "af60eea9": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "skipSearch": false
    }],
    "foppaluera": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ed46ca2f": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "skipSearch": false
    }],
    "molinazzo": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a9bd7f84": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "skipSearch": false
    }],
    "palazzetto": [{
      "hkey": "d850e21b",
      "slug": "brivio",
      "name": "Brivio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd3cebcf": [{
      "hkey": "f0b148b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "toffo": [{
      "hkey": "f0b148b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brivio"
    }],
    "0739bea6": [{
      "hkey": "f0b148b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "vaccarezza": [{
      "hkey": "f0b148b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brivio"
    }]
  }
};
exports["default"] = _default;